import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { customerQueries } from '@/queries/customer';

export const txUsersLoader = (queryClient: QueryClient) => () => {
  return queryClient.ensureQueryData(customerQueries.list({ itemsPerPage: LIST_ITEMS_COUNT, pageIndex: 0 }));
};

export const txUserByIdLoader = (queryClient: QueryClient) => (txUserId: string) => {
  return queryClient.fetchQuery({
    ...customerQueries.item(txUserId),
  });
};

export const composedTxUserByIdLoader = (queryClient: QueryClient) => (txUserId: string) => {
  return queryClient.fetchQuery({
    ...customerQueries.composedItem(txUserId),
  });
};
